import {
  DeviceFunctionStage,
  ExecuteDeviceFunctionQueryArg,
} from '@/redux/api/endpoints/device-functions';

type AlexaRequest<TFunction extends ExecuteDeviceFunctionQueryArg['function']> =
  Extract<ExecuteDeviceFunctionQueryArg, { function: TFunction }>;

export const buildGetDeviceDetailsRequest = (
  deviceId: number,
): AlexaRequest<'get-device'> => ({
  deviceId,
  function: 'get-device',
});

export const buildGetUnitInfoRequest = (
  deviceId: number,
): AlexaRequest<'get-room'> => ({
  deviceId,
  function: 'get-room',
});

export const buildDeletePvaRequest = (
  deviceId: number,
): AlexaRequest<'delete-pva'> => ({
  deviceId,
  function: 'delete-pva',
});

export const buildEnableSkillRequest = (
  deviceId: number,
  skillId: string,
  stage: DeviceFunctionStage,
): AlexaRequest<'enable-skill'> => ({
  deviceId,
  function: 'enable-skill',
  arguments: { skillId, stage },
});
